import React, { useState } from "react";

const First = ({ clickHandler }) => {
  const [data, setData] = useState("");

  const handleChange = (e) => {
    setData(e.target.value);
  };

  return (
    <>
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                شماره سفارش را وارد کنید
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="form-floating mb-3">
                <input
                  type="text"
                  className="form-control"
                  id="floatingInput"
                  name="order"
                  placeholder="XXXXXX"
                  value={data}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInput">شماره سفارش</label>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                بستن
              </button>
              <button
                className={"btn btn-primary"}
                onClick={() => clickHandler(data)}
                data-bs-dismiss="modal"
              >
                پیگیری
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default First;
